import React from 'react';
import { Link } from 'react-scroll';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <h3>
              Heal<span>AI</span>
            </h3>
            <p>Transforming healthcare with AI</p>
          </div>
          <div className="footer-links">
            <div className="link-group">
              <h4>Quick Links</h4>
              <ul>
                <li>
                  <Link to="home" smooth={true} offset={-80} duration={500}>
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="about" smooth={true} offset={-80} duration={500}>
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="solution" smooth={true} offset={-80} duration={500}>
                    Our solution
                  </Link>
                </li>
                <li>
                  <Link to="how-it-works" smooth={true} offset={-80} duration={500}>
                    How It Works
                  </Link>
                </li>
              </ul>
            </div>
            <div className="link-group">
              <h4>Connect</h4>
              <ul>
                <li>
                  <Link to="contact" smooth={true} offset={-80} duration={500}>
                    Contact
                  </Link>
                </li>
                <li>
                  <a href="#">Privacy Policy</a>
                </li>
                <li>
                  <a href="#">Terms of Service</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="copyright">
          <p>&copy; 2025 GVA Health Tech Pvt Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
